// 제품 바깥에 있는 고정 링크입니다.
//
// 로그인 후의 사이드바 Help 메뉴와 비로그인 상단바가 같은 곳을 가리켜야 하므로,
// 주소를 여기 한 곳에서만 관리합니다. 각 화면에 문자열을 직접 적어 두면 한쪽만
// 바꾸고 다른 쪽을 놓치기 쉽습니다.
//
// 두 서비스 모두 GRAP 저장소 바깥에 있으므로, 주소가 바뀌면 여기도 함께
// 수정해 주세요.

export const GUIDE_URL = 'https://growin-portal.apps.ktwcs.growin.co.kr/grap';

export const HELPDESK_URL =
  'https://helpdesk.apps.ktwcs.growin.co.kr/login?next=%2F';

// 새 탭으로 열되 원본 창에 대한 참조(window.opener)는 넘기지 않습니다.
export const openExternal = (url) => {
  window.open(url, '_blank', 'noopener,noreferrer');
};
